import { Pipe, PipeTransform } from '@angular/core';
import Hashids from 'hashids';
import { environment } from 'src/environments/environment';

@Pipe({
	name: 'hashid'
})
export class HashidPipe implements PipeTransform
{
	private hashids = new Hashids
	(
		environment.app_settings.hashids_salt,
		environment.app_settings.hashids_length,
		environment.app_settings.hashids_alphabet
	);

	transform(value: number | string | null | undefined): string
	{
		if( value === null || value === undefined || value === '' )
			return '';

		let number_value = typeof value == 'number'
			? value
			: parseInt(value, 10);

		if( isNaN(number_value) )
			return '';

		return this.hashids.encode(number_value);
	}
}
